<template>
  <div class="contactos">
    <div class="header">
      <div class="custom-label">Contactos</div>
      <el-button
        type="primary"
        size="small"
        @click="addContacto"
        >+ Agregar contacto</el-button
      >
    </div>

    <el-empty
      v-if="!localList.length"
      description="Sin contactos"
    />

    <el-card
      v-for="(c, i) in localList"
      :key="i"
      class="contact-card"
      shadow="never"
    >
      <div class="card-header">
        <div class="title">Contacto #{{ i + 1 }}</div>
        <el-button
          type="danger"
          link
          @click="removeContacto(i)"
          >Eliminar</el-button
        >
      </div>

      <el-row :gutter="24">
        <el-form-item :prop="`${propPrefix}.${i}.Nombre`">
          <custom-input
            v-model="c.Nombre"
            :label="'Nombre'"
            :settings="{ placeholder: 'Nombre (opcional)', maxlength: 80 }"
          />
        </el-form-item>

        <el-form-item :prop="`${propPrefix}.${i}.Apellido`">
          <custom-input
            v-model="c.Apellido"
            :label="'Apellido'"
            :settings="{ placeholder: 'Apellido (opcional)', maxlength: 80 }"
          />
        </el-form-item>
      </el-row>

      <el-row :gutter="24">
        <el-form-item :prop="`${propPrefix}.${i}.Email`">
          <custom-input
            v-model="c.Email"
            :label="'Email'"
            :settings="{ placeholder: 'correo@dominio.com (opcional)', maxlength: 80 }"
          />
        </el-form-item>

        <el-form-item :prop="`${propPrefix}.${i}.TelefonoPrincipal`">
          <custom-input
            v-model="c.TelefonoPrincipal"
            :label="'Teléfono principal'"
            :settings="{ placeholder: 'Opcional', maxlength: 30 }"
          />
        </el-form-item>

        <el-form-item :prop="`${propPrefix}.${i}.TelefonoSecundario`">
          <custom-input
            v-model="c.TelefonoSecundario"
            :label="'Teléfono secundario'"
            :settings="{ placeholder: 'Opcional', maxlength: 30 }"
          />
        </el-form-item>
      </el-row>
    </el-card>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import CustomInput from '@/shared/components/custom_input.vue';

const props = defineProps({
  modelValue: { type: Array, default: () => [] },
  propPrefix: { type: String, default: 'Contactos' },
});

const emit = defineEmits(['update:modelValue']);

const localList = computed({
  get: () => props.modelValue || [],
  set: (val) => emit('update:modelValue', val),
});

const empty = () => ({
  Nombre: '',
  Apellido: '',
  Email: '',
  TelefonoPrincipal: '',
  TelefonoSecundario: '',
});

function addContacto() {
  localList.value = [...localList.value, empty()];
}
function removeContacto(index) {
  const next = [...localList.value];
  next.splice(index, 1);
  localList.value = next;
}
</script>

<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
}
.custom-label {
  font-weight: 700;
  color: #111;
}
.contact-card {
  margin-bottom: 12px;
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.title {
  font-weight: 600;
}
</style>
